import React, { useEffect, useState } from "react";

interface UseCountdownProps {
  startTime: string;
  onCountdownEnd?: () => void;
}

export function useCountdown({ startTime, onCountdownEnd }: UseCountdownProps) {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (!startTime) return;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const st = new Date(startTime).getTime();
      const timeDiff = st - now;
      const s = Math.floor(timeDiff / 1000);
      setSeconds(s);
      if (s <= 0) {
        setSeconds(0);
        clearInterval(interval);
        onCountdownEnd && onCountdownEnd();
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [startTime]);

  return seconds;
}
